const SEO = [
	{
		page: "home",
		description:
			"I'm passionate about creating delightful user experiences through web development. As a software engineer and front-end web developer, I specialize in crafting responsive and interactive web applications that not only meet but exceed user expectations.",
		keywords: ["Fadel", "Razsiah", "Fadel Razsiah"],
	},

	{
		page: "about",
		description:
			"I am a recent graduate from Politeknik Manufaktur Negeri Bangka Belitung with a degree in Software Engineering. I am very enthusiastic about web development, with a strong focus on becoming a Frontend Engineer. As a beginner in the field of software and web development, I am committed to learning and honing my skills while staying updated with the latest industry trends.",
		keywords: ["Fadel", "Razsiah", "Fadel Razsiah"],
	},

	{
		page: "projects",
		description:
			"Throughout my career, I've embarked on diverse projects that highlight my growth and dedication. Many of these endeavors are open-source, inviting collaboration and innovation. Feel free to explore their codebases and share your insights. Collaborating with others enriches my learning journey, and I welcome new ideas and feedback.",
		keywords: ["Fadel", "Razsiah", "Fadel Razsiah"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Fadel", "Razsiah", "Fadel Razsiah"],
	},
];

export default SEO;
